/* eslint-disable class-methods-use-this */
import * as api from '../../../utils/apiClient';

class I18NMainService {
  async getTranslationGuideAction() {
    const response = await api.get(
      `/kernel/i18n/locale/translation-guide`,
      {},
      {}
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async sendNotFoundMessageAction(sourceMessage) {
    const response = await api.post(
      '/kernel/i18n/locale/send-not-found-message',
      {},
      { source_message: sourceMessage }
    );
    if (response) {
      const responseJson = await response.json();
      return responseJson;
    }
    return null;
  }
}

export default new I18NMainService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/i18n/services/I18NLocaleService.js